import { Injectable } from '@angular/core';
import { AppTokens } from 'src/app/models/authentications/access-token.model';
import { Authentication } from '../../../configs/authentication';
import { DateHelper } from '../../../models/helpers/date-helper';
import { Params } from '@angular/router';

const REDIRECT_KEY = 'redirectTo';

@Injectable({
    providedIn: 'root',
})
export class AuthenticationService {

    private appTokens?: AppTokens;

    private storageKey = 'authorization';

    private renewTokenBeforeExpiresInMinutes = 10;

    private recoveryEmail: string;

    constructor() {
        this.loadTokens();
    }

    public saveToken(tokens: AppTokens) {
        this.appTokens = tokens;
        this.storeTokens();
    }

    public getAcessToken(): string {
        if (this.appTokens && this.appTokens.accessToken) {
            return this.appTokens.accessToken;
        }
        return '';
    }

    public getTokenExpires(): Date {
        if (this.appTokens && this.appTokens.expiresIn) {
            return this.appTokens.expiresIn;
        }
        return new Date();
    }

    public isTokenExpired() {
        const expires = this.getTokenExpires();
        const date = new Date();
        return !expires || date >= expires;
    }

    public shouldRefreshToken() {
        if (this.isTokenExpired()) return true;
        let expiresAt = this.getTokenExpires();
        if (Authentication.RENEW_TOKEN_BEFORE_EXPIRE_IN_MINUTES > 0) {
            expiresAt = DateHelper.addMinutes(expiresAt, -Authentication.RENEW_TOKEN_BEFORE_EXPIRE_IN_MINUTES);
        }
        const date = new Date();
        return (expiresAt && date >= expiresAt);
    }

    public getRefreshToken(): string | null {
        if (this.appTokens && this.appTokens.refreshToken) {
            return this.appTokens.refreshToken;
        }
        return null;
    }

    public removeToken() {
        this.appTokens = undefined;
        localStorage.removeItem(this.storageKey);
    }

    public setRecoveryEmail(email: string) {
        this.recoveryEmail = email;
    }

    public getRecoveryEmail(): string {
        if (this.recoveryEmail) {
            return this.recoveryEmail;
        }
        return '';
    }

    private loadTokens() {
        try {
            if (localStorage && localStorage.getItem) {
                const tokensString = localStorage.getItem(this.storageKey);
                if (tokensString) {
                    const tokens = tokensString.split(':');
                    if (tokens.length === 3) {
                        this.appTokens = new AppTokens({
                            access_token: tokens[0],
                            refresh_token: tokens[1],
                            expiresIn: new Date(parseInt(tokens[2], 10))
                        });
                    }
                }
            }
        }
        catch {
        }
    }

    private storeTokens() {
        if (localStorage && localStorage.setItem && this.appTokens) {
            localStorage.setItem(
                this.storageKey,
                this.appTokens.accessToken + ':' + this.appTokens.refreshToken + ':' + this.appTokens.expiresIn.valueOf()
            );
        }
    }


    public getQueryParamsForRedirect(url: string) {
        return {[REDIRECT_KEY]: url};
    }

    public getRedirectToFromQueryParams(params: Params) {
        return params[REDIRECT_KEY] || '/admin/plantingSites';
    }
}
